import TextImageCard from "components/card/TextImageCard";
import Markdown from "markdown-to-jsx";
import { useEffect, useState } from "react";
import { useInView } from "react-cool-inview";
import styles from "./ItineraryItem.module.scss";

import ViatorProductCard from "@/components/card/viator/ViatorProductCard";
// import { viatorFreetextSearchClient } from "utils/helpers/viator";

// import { filterViatorProductsByDistanceFromBoundingBox } from "pages/api/external/viator/products/index";

export default function ItineraryItem({
  item,
  layout,
  location,
  setItineraryItems,
  viatorActivity,
}) {
  const [fetchedViatorActivities, setFetchedViatorActivities] = useState(false);
  const [viatorFetchFinished, setViatorFetchFinished] = useState(false);
  const { observe, inView } = useInView({
    threshold: 0.25,
    unobserveOnEnter: true,
  });

  const { description, image, day, activities, id } = item;

  // const primaryActivity = Array.isArray(activities)
  //   ? (activities?.find((activity) => activity?.is_primary_activity) ??
  //     activities[(Math.random() * activities?.length) | 0])
  //   : null;

  // const viatorDestination =
  //   location?.destinations[0]?.destination_details?.viator_destination_info
  //     ?.destination_id ?? null;

  // useEffect(() => {
  //   console.log(viatorFetchFinished);
  // }, [viatorFetchFinished]);

  // useEffect(() => {
  //   if (!inView) {
  //     return;
  //   }

  //   if (!!fetchedViatorActivities) {
  //     return;
  //   }

  //   (async () => {
  //     try {
  //       if (!activities[0]?.title || !!item?.viatorActivity) {
  //         return;
  //       }

  //       const searchTerm = `${
  //         `${primaryActivity?.title} ${location?.city} ${primaryActivity?.location}` ??
  //         primaryActivity?.title
  //       }`;

  //       const viatorResponse = await viatorFreetextSearchClient({
  //         searchTerm,
  //         currencyCode: "USD",
  //         count: 2,
  //         withDestinationInfo: true,
  //         withGeocodeInfo: true,
  //         location: {
  //           country: location?.country,
  //           country_code: location?.country_code,
  //           bounding_box: location?.bounding_box,
  //           lat: location?.lat,
  //           lon: location?.lon,
  //           region: location?.region,
  //         },
  //         //TODO: Re-add destination if Viator figures out what's going wrong
  //         productFilters: {
  //           // destination:
  //           //   location?.destinations[0]?.destination_details
  //           //     ?.viator_destination_info?.destination_id ?? null,
  //           price: {
  //             from: 50,
  //           },
  //           rating: {
  //             from: 3,
  //             to: 5,
  //           },
  //         },
  //         destination:
  //           location?.destinations[0]?.destination_details
  //             ?.viator_destination_info?.destination_id ?? null,
  //       });

  //       setItineraryItems((prev) => {
  //         const products = viatorResponse?.products;
  //         const indexToReplace = prev.findIndex((itineraryItem) => {
  //           return itineraryItem?.id === id;
  //         });

  //         if (Array.isArray(prev) && prev?.length === 0) {
  //           const replacementArray = prev?.toSpliced(indexToReplace, 1, {
  //             ...prev[indexToReplace],
  //             viatorActivity: products[0] ?? null,
  //           });

  //           return replacementArray;
  //         }

  //         const existingProductCodes = prev
  //           ?.map((itineraryItem) => {
  //             return itineraryItem?.viatorActivity?.productCode;
  //           })
  //           .filter((productCode) => productCode);

  //         const uniqueNewProducts = viatorResponse?.products?.filter(
  //           (product) => {
  //             const isUnique = !existingProductCodes?.includes(
  //               product?.productCode
  //             );

  //             const doesNotContainBannedKeywords = ![
  //               "transfer",
  //               "airport",
  //               "taxi",
  //               "shuttle",
  //               "pick-up",
  //               "pick up",
  //             ].some((word) => product?.title?.toLowerCase().includes(word));

  //             return isUnique && doesNotContainBannedKeywords;
  //           }
  //         );

  //         if (!uniqueNewProducts?.length) {
  //           return prev;
  //         }
  //         const locationCoordinates = {
  //           lat: location?.lat,
  //           lon: location?.lon,
  //         };

  //         const productsInProximityToLocation =
  //           filterViatorProductsByDistanceFromBoundingBox({
  //             products: uniqueNewProducts,
  //             boundingBox: location?.bounding_box,
  //             tolerance: 2,
  //           });

  //         if (!productsInProximityToLocation?.length) {
  //           return prev;
  //         }

  //         const replacementArray = prev?.toSpliced(indexToReplace, 1, {
  //           ...prev[indexToReplace],
  //           viatorActivity: productsInProximityToLocation[0] ?? null,
  //         });

  //         return replacementArray;
  //       });

  //       setFetchedViatorActivities(true);
  //     } catch (error) {
  //       console.error("Error fetching Viator activities", error);
  //     } finally {
  //       setViatorFetchFinished(true);
  //     }
  //   })();
  // }, [
  //   activities,
  //   primaryActivity,
  //   location,
  //   setItineraryItems,
  //   id,
  //   fetchedViatorActivities,
  //   item?.viatorActivity,
  //   inView,
  // ]);

  const title = `Day ${day}`;
  const text = <ActivitiesList activities={activities} />;

  if (layout === "text-image") {
    return (
      <div className={`${styles.itineraryItem}`} id={`itinerary-day-${day}`}>
        <TextImageCard
          title={title}
          description={description}
          image={image.url}
          text={text}
          imageSide={day % 2 === 0 ? "left" : "right"}
          observe={observe}
        />
      </div>
    );
  }

  if (layout === "text") {
    return (
      <div className={`${styles.itineraryItem}`} id={`itinerary-day-${day}`}>
        <TextCard
          title={title}
          description={description}
          text={text}
          observe={observe}
        />

        <div className={`${styles.viator}`}>
          {item?.viatorActivity && (
            <ViatorProductCard
              product={item?.viatorActivity}
              cardType="large"
              isLoaded={item?.viatorActivity && item?.viatorActivity !== null}
              truncateTitleTo={128}
            />
          )}
        </div>
      </div>
    );
  }
}

function TextCard({ text, title, description, observe }) {
  return (
    <article className={`${styles.textCard}`} ref={observe}>
      <p className={`${styles.textCardTitle}`}>{title}</p>
      <p className={`${styles.textCardDescription}`}>{description}</p>
      <div>{text}</div>
    </article>
  );
}

function ActivitiesList({ activities, observe }) {
  if (!activities) {
    return null;
  }

  return (
    <ul className={`${styles.activities}`} ref={observe}>
      {activities?.map((activity, index) => (
        <li key={`activity-${index}`} className={`${styles.activity}`}>
          {activity?.title && (
            <p className={`${styles.activityTitle}`}>{activity.title}</p>
          )}
          <Markdown>{activity.text}</Markdown>
        </li>
      ))}
    </ul>
  );
}
